import { Button } from '../.';

const FileUploaderDragDropActions = ({
  controlUploadDisabled,
  messages,
  onCancel,
  onUpload,
  uploadText
}) => (
  <div className="actions">
    <Button
      category="light"
      onClick={onCancel}
      style={{ marginRight: 10 }}
      text={messages.commonCancel}
    />
    <Button
      aria-label={controlUploadDisabled ? messages.uploaderDisabled : null}
      category="success"
      data-tooltip={controlUploadDisabled ? messages.uploaderDisabled : null}
      disabled={controlUploadDisabled}
      onClick={onUpload}
      text={uploadText}
      type="button"
    />

    <style jsx>{`
      .actions {
        margin-top: 15px;
        text-align: right;
      }
    `}</style>
  </div>
);

export default FileUploaderDragDropActions;
